<div class="control-container">
  <form [formGroup]="form" *ngIf="!loading; else loadingTemplate">
    <glxy-form-field suffixIcon="search" required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.SEARCH' | translate }}
      </glxy-label>
      <input type="text" [matAutocomplete]="auto" [formControl]="form.controls.template" matInput />
      <mat-autocomplete #auto [displayWith]="templateTitle">
        <ng-container *ngIf="yourTemplates$ | async as yourTemplates">
          <ng-container *ngIf="yourTemplates.length > 0">
            <mat-optgroup
              [label]="'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.YOUR_TEMPLATES' | translate"
              class="create-project-optgroup"
            >
              <mat-option *ngFor="let template of yourTemplates" [value]="template">
                {{ template.title }}
              </mat-option>
            </mat-optgroup>
          </ng-container>
        </ng-container>
        <mat-option *ngIf="disablePartnerSpecificTemplateSelection$ | async" [value]="undefined">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.UNSPECIFIED_TEMPLATE' | translate }}
        </mat-option>
        <ng-container *ngIf="systemTemplates$ | async as systemTemplates">
          <ng-container *ngIf="systemTemplates.length > 0">
            <mat-optgroup
              [label]="'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.SYSTEM_TEMPLATES' | translate"
              class="create-project-optgroup"
            >
              <mat-option *ngFor="let template of systemTemplates" [value]="template">
                {{ template.title }}
              </mat-option>
            </mat-optgroup>
          </ng-container>
        </ng-container>
      </mat-autocomplete>
    </glxy-form-field>
    <glxy-alert type="tip" *ngIf="templateProductName(form.controls?.template?.value) | async as productID">
      <div
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.PRODUCT_ACTIVATION_WARNING'
            | translate : { productName: productID }
            | iTrustThisHtml
        "
      ></div>
    </glxy-alert>
  </form>
</div>

<ng-template #loadingTemplate>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
